import React, { useState } from "react";
import "./DescriptionBox.css";

const DescriptionBox = () => {
  const [activeTab, setActiveTab] = useState("description");

  return (
    <div className="descriptionbox-container">
      <div className="descriptionbox">
        <div className="descriptionbox-navigator">
          <div 
            className={`descriptionbox-nav-box ${activeTab === 'description' ? 'active' : ''}`}
            onClick={() => setActiveTab('description')}
          >
            Description
          </div>
          <div 
            className={`descriptionbox-nav-box ${activeTab === 'reviews' ? 'active' : ''}`}
            onClick={() => setActiveTab('reviews')}
          >
            Reviews (122)
          </div>
        </div>
        
        <div className="descriptionbox-content">
          {activeTab === 'description' ? (
            <div className="descriptionbox-description">
              <h3>Product Details</h3>
              <p>
                Our premium medical equipment is crafted with precision and care, 
                designed to meet the highest industry standards. Each piece undergoes 
                rigorous quality control to ensure reliability in clinical settings.
              </p>
              <ul className="features-list">
                <li>FDA-approved materials</li>
                <li>Ergonomic design for professional use</li>
                <li>Easy-to-clean surfaces</li>
                <li>3-year manufacturer warranty</li>
              </ul>
            </div>
          ) : (
            <div className="descriptionbox-reviews">
              <h3>Customer Feedback</h3>
              <div className="review-summary">
                <div className="rating">★★★★★ 4.8/5</div>
                <div className="review-count">Based on 122 reviews</div>
              </div>
              <div className="review-highlight">
                "This equipment has transformed our clinic's efficiency. The build quality 
                is exceptional and it's incredibly user-friendly." - Dr. Sarah Johnson
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DescriptionBox;